import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ceil from 'lodash/ceil';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import 'Components/Timers/ProductTimer.scss';

export default function ProductTimer({ endDate, startDate, productHeader, dayRestriciton }) {
  const calculateCountdown = (countDownEndDate) => {
    const timeLeft = {
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
    };

    if (countDownEndDate > Date.now()) {
      const dealTimeLeft = (countDownEndDate - Date.now()) / 1000;
      const remainingMins = dealTimeLeft / 60;

      timeLeft.days = Math.floor(remainingMins / 1440);
      timeLeft.hours = Math.floor((remainingMins / 60) % 24);
      timeLeft.min = Math.floor(remainingMins % 60);
      timeLeft.sec = Math.floor(dealTimeLeft % 60);
    }

    return timeLeft;
  };

  const [time, setTime] = useState(calculateCountdown(endDate));

  useEffect(() => {
    let timer;
    if (endDate > Date.now()) {
      timer = setTimeout(() => {
        let timeLeft = {
          days: 0,
          hours: 0,
          min: 0,
          sec: 0,
        };

        timeLeft = calculateCountdown(endDate);
        setTime(timeLeft);
      }, 1000);
    }

    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

  const { days, hours, min, sec } = time;
  const oneDay = (24 * 60) * 60;
  let progressPeriod = oneDay * 14; // Timer coundown period set to 14 days
  if (startDate > 0) {
    progressPeriod = (endDate - startDate) / 1000;
  }

  const dealSecondsRemaining = (endDate - Date.now()) / 1000;
  const dealPercentageLeft = ceil((dealSecondsRemaining / progressPeriod) * 100);

  // If the time left is greater than the progress period
  // or time goes past the end date, don't show the timer
  if (dealSecondsRemaining > progressPeriod || Date.now() >= endDate) return false;
  if (!endDate) return false;
  if (dayRestriciton && days > dayRestriciton) return false;

  return (
    <div className={classNames('product-timer-progress-container', { 'new-design': productHeader })}>
      {productHeader &&
        <div className="product-timer-end-text">
          <FormattedMessage id="product-page-timer.label.ends" defaultMessage="This deal ends in:" />
        </div>
      }
      <div className="progress-container progress-container-challenger">
        <div className="progress progress-challenger">
          <div
            className="progress-bar progress-bar-striped progress-bar-animated progress-red"
            role="progressbar"
            style={{ width: `${dealPercentageLeft}%` }}
            aria-valuenow={dealPercentageLeft}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label="This deal ends in"
            title="This deal ends in"
          />
          <div className="countdown-container countdown-container-challenger">
            {!productHeader &&
              <div className="countdown-label-challenger">
                <FormattedMessage id="product-page-timer.countdown-label" defaultMessage="Deal ends:" />
              </div>
            }
            <div className="countdown-timer">
              {days < 10 ? `0${days}` : days}
              {productHeader && <span>D</span>}
              <span className="colon">:</span>
              {hours < 10 ? `0${hours}` : hours}
              {productHeader && <span>H</span>}
              <span className="colon">:</span>
              {min < 10 ? `0${min}` : min}
              {productHeader && <span>M</span>}
              <span className="colon">:</span>
              {sec < 10 ? `0${sec}` : sec}
              {productHeader && <span>S</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ProductTimer.propTypes = {
  endDate: PropTypes.number,
  startDate: PropTypes.number,
  productHeader: PropTypes.bool,
  dayRestriciton: PropTypes.number,
};

ProductTimer.defaultProps = {
  endDate: 0,
  startDate: 0,
  productHeader: false,
  dayRestriciton: null,
};
